export type AdditionalInfo = {
	gitUserName: string;
	gitUserEmail: string;
	branchName: string;
	prompt: string;
};

export function deserializeAdditionalInfo(serializedAdditionalInfo: string): AdditionalInfo {
	try {
		return JSON.parse(serializedAdditionalInfo);
	} catch (error) {
		return { gitUserName: '', gitUserEmail: '', branchName: '', prompt: '' };
	}
}

export const serializeAdditionalInfo = (additionalInfo: AdditionalInfo): string => {
	try {
		return JSON.stringify(additionalInfo);
	} catch (error) {
		console.error('Error serializing additional info:', error);
		return '';
	}
};
